module.exports = __webpack_public_path__ + "static/media/ic_searchtype_lightsatons.15809221.svg";